import { buildAxonItem, pushAxonEvent } from '@/utils/axonTrack'

export function useAxonBeginCheckout() {
  function reportBeginCheckout(
    productId: string | number,
    contentId: string | number | undefined,
    itemName: 'Coins Package' | 'Membership',
    price: string | number,
  ) {
    pushAxonEvent('begin_checkout', {
      currency: 'USD',
      value: Number(price),
      items: [buildAxonItem(productId, contentId, itemName, price)],
    })
  }

  return { reportBeginCheckout }
}
